let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eOJJI")).then(() => parcelRequire('gnKsg'));